import React from 'react';
import { compose, lifecycle, withState, withHandlers, withProps } from 'recompose';
import { get, sortBy, find } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  allReservations,
  reservationStatusNames,
  printPdfDocument,
  unreturnedReservations,
  allReservationsForUser,
  archivedReservations,
  archivedReservationsForUser,
} from './_api';
import { users } from '../users/_api';
import withLoader from '../../modules/app/withLoader';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { Grid, Table, TableHeaderRow, TableFilterRow } from '@devexpress/dx-react-grid-material-ui';
import { withSnackbar } from 'notistack';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  FilteringState,
  IntegratedFiltering,
} from '@devexpress/dx-react-grid';
import moment from 'moment';
import { Tabs, Tab } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Select from 'react-select';
import Add from './add';

const DateFormatter = ({ value }) => moment(value).format('DD.MM.YYYY, HH:mm:ss');

const DateTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={DateFormatter} {...props} />
);

const dateTimePredicate = (value, filter) =>
  moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss').startsWith(filter.value);

const integratedFilteringColumnExtensions = [
  { columnName: 'createdDate', predicate: dateTimePredicate },
  { columnName: 'from', predicate: dateTimePredicate },
  { columnName: 'to', predicate: dateTimePredicate },
];

const enhance = compose(
  withRouter,
  withLoader,
  withSnackbar,
  withState('items', 'setItems', []),
  withState('unreturnedItems', 'setUnreturnedItems', []),
  withState('statusNames', 'setStatusNames', []),
  withState('activeTab', 'setActiveTab', 'new'),
  withState('users', 'setUsers', null),
  withHandlers({
    loadItems:
      ({ setItems, toggleLoader, setUsers }) =>
      async (type, id = null) => {
        setItems([]);
        toggleLoader();
        let reservations = [];
        if (type === 'active') {
          const resp = await allReservations();
          reservations = get(resp, 'items', []);
        }
        if (type === 'unreturned') {
          reservations = await unreturnedReservations();
        }
        if (type === 'forUser') {
          const resp = await users();
          if (resp) {
            setUsers(resp.items);
          }
        }
        if (type === 'archive') {
          const resp = await archivedReservations();
          reservations = get(resp, 'items', []).map((item) => ({ ...item, archived: true }));
        }
        setItems(reservations);
        toggleLoader(false);
      },
  }),
  withHandlers({
    loadSelectedItems:
      ({ loadItems }) =>
      async (value) => {
        await loadItems(value);
      },
  }),
  lifecycle({
    async componentDidMount() {
      const {
        setStatusNames,
        match: {
          params: { category },
        },
      } = this.props;
      this.props.setActiveTab(category || 'new');
      const statusNames = await reservationStatusNames();
      if (statusNames) {
        setStatusNames(statusNames);
      }
      if (category) {
        await this.props.loadSelectedItems(category);
      }
    },
  }),
  /* lifecycle({
    async componentWillReceiveProps(nextProps) {
      const { loadItems } = this.props;
      if (this.props.reload !== nextProps.reload) {
        loadItems();
      }
    },
  }),*/
  connect(
    (state) => ({
      isMiniMode: get(state, 'app.miniMode', false),
    }),
    null
  ),
  withHandlers({
    redirectTo:
      ({ history }) =>
      (id, archived = false) => {
        history.push(`/reservations/${id}?archived=${archived}`);
      },
    handleTabChange:
      ({ loadSelectedItems, setActiveTab, history }) =>
      async (event, value) => {
        setActiveTab(value);
        history.push(`/reservations/${value}`);
        await loadSelectedItems(value);
      },
    TabContainer: () => (props) => {
      return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
          {props.children}
        </Typography>
      );
    },
  }),
  withHandlers({
    TableRow:
      ({ redirectTo, isMiniMode }) =>
      ({ row, ...restProps }) =>
        (
          <Table.Row
            {...restProps}
            style={{
              cursor: 'pointer',
              ...(isMiniMode ? { height: 'auto' } : {}),
              ':hover': { background: '#7eb6e4' },
            }}
            onClick={() => redirectTo(get(row, 'id'), get(row, 'archived', false))}
          />
        ),
    TableHeaderRowCustom:
      ({ isMiniMode }) =>
      (props) =>
        (
          <Table.Row
            {...props}
            style={{
              ...(isMiniMode ? { height: 'auto' } : {}),
            }}
          />
        ),
  }),
  withProps(({ setDialog, statusNames, toggleLoader, enqueueSnackbar, activeTab, isMiniMode }) => {
    return {
      columns: [
        { name: 'id', title: 'id' },
        {
          name: 'user',
          title: 'Zákazník',
          getCellValue: (row) => `${get(row, 'user.surname', '')} ${get(row, 'user.forename', '')}`,
        },
        {
          name: 'status',
          title: 'Status',
          getCellValue: (row) => get(find(statusNames, { flagValue: row.status }), 'name'),
        },
        { name: 'from', title: 'Od' },
        { name: 'to', title: 'Do' },
        { name: 'note', title: 'Poznámka' },
        { name: 'createdDate', title: 'Vytvořeno' },
        ...(activeTab !== 'archive'
          ? [
              {
                name: 'print',
                title: 'Tisk',
                getCellValue: (row) => (
                  <div style={{ display: 'flex' }}>
                    <div>
                      <Button
                        variant="outlined"
                        size={isMiniMode ? 'small' : 'medium'}
                        onClick={async (e) => {
                          e.stopPropagation();
                          toggleLoader();
                          const data = await printPdfDocument(row.id, 'reservation');
                          const dataB64 = get(data, 'data');
                          if (dataB64) {
                            const linkSource = `data:application/pdf;base64,${dataB64}`;
                            var a = document.createElement('a');
                            a.href = linkSource;
                            a.download = `R-${get(row, 'user.surname', '')}-${get(
                              row,
                              'id',
                              ''
                            )}-${moment(get(row, 'from')).format('YYMMDD')}.pdf`;
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                          } else {
                            enqueueSnackbar('Pdf dokument se nepodařilo vygenerovat.', {
                              variant: 'error',
                            });
                          }
                          toggleLoader(false);
                        }}
                      >
                        R
                      </Button>
                    </div>
                    <div>
                      <Button
                        variant="outlined"
                        size={isMiniMode ? 'small' : 'medium'}
                        onClick={async (e) => {
                          e.stopPropagation();
                          toggleLoader();
                          const data = await printPdfDocument(row.id, 'contract');
                          const dataB64 = get(data, 'data');
                          if (dataB64) {
                            const linkSource = `data:application/pdf;base64,${dataB64}`;
                            var a = document.createElement('a');
                            a.href = linkSource;
                            a.download = `S-${get(row, 'user.surname')}-${get(
                              row,
                              'id',
                              ''
                            )}-${moment(get(row, 'from')).format('YYMMDD')}.pdf`;
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                          } else {
                            enqueueSnackbar('Pdf dokument se nepodařilo vygenerovat.', {
                              variant: 'error',
                            });
                          }
                          toggleLoader(false);
                        }}
                      >
                        S
                      </Button>
                    </div>
                  </div>
                ),
              },
            ]
          : []),

        {
          name: 'delete',
          title: ' ',
          getCellValue: (row) => (
            <Button
              variant="outlined"
              size={isMiniMode ? 'small' : 'medium'}
              onClick={(e) => {
                e.stopPropagation();
                setDialog({ open: true, id: row.id, action: 'reservation-delete' });
              }}
            >
              Smazat
            </Button>
          ),
        },
      ],
    };
  })
);

export default enhance(
  ({
    items,
    TableRow,
    columns,
    activeTab,
    handleTabChange,
    TabContainer,
    users,
    setItems,
    toggleLoader,
    TableHeaderRowCustom,
  }) => (
    <div style={{ margin: 10 }}>
      <Tabs value={activeTab} onChange={handleTabChange} scrollable scrollButtons="auto">
        <Tab key={'new'} label={'Nová'} value="new" />
        <Tab key={'active'} label={'Aktivní'} value="active" />
        <Tab key={'unreturned'} label={'Nevrácené'} value="unreturned" />
        <Tab key={'forUser'} label={'Podle uživatele'} value="forUser" />
        <Tab key={'archive'} label={'Archivované'} value="archive" />
      </Tabs>
      <TabContainer>
        {activeTab === 'new' && <Add />}
        {activeTab === 'forUser' && users ? (
          <div style={{ width: '300px', marginBottom: '10px' }}>
            <Select
              onChange={async (value) => {
                toggleLoader();
                const userId = get(value, 'value', null);
                if (userId) {
                  const [resp, resp2] = await Promise.all([
                    allReservationsForUser(userId),
                    archivedReservationsForUser(userId),
                  ]);
                  setItems([...get(resp, 'items', []), ...get(resp2, 'items', [])]);
                }
                toggleLoader(false);
              }}
              options={sortBy(users, ['surname']).map((item) => ({
                value: item.id,
                label: `${item.surname} ${item.forename} (${item.phone})`,
              }))}
              placeholder="Vyber"
            />
          </div>
        ) : null}
        {activeTab !== 'new' ? (
          <Paper>
            <div className="grid--clickable grid--custom">
              <Grid rows={items} columns={columns}>
                <SortingState defaultSorting={[{ columnName: 'createdDate', direction: 'desc' }]} />
                <DateTypeProvider for={['createdDate', 'from', 'to']} />
                <FilteringState defaultFilters={[]} />
                <IntegratedSorting />
                <IntegratedFiltering columnExtensions={integratedFilteringColumnExtensions} />
                <Table rowComponent={TableRow} />
                <TableHeaderRow showSortingControls rowComponent={TableHeaderRowCustom} />
                <TableFilterRow rowComponent={TableHeaderRowCustom} />
              </Grid>
            </div>
          </Paper>
        ) : null}
      </TabContainer>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/reservations/index.js